import { ApiEntity } from '@backstage/catalog-model';
import {
  configApiRef,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import {
  apiDocsConfigRef,
  defaultDefinitionWidgets,
} from '@backstage/plugin-api-docs';
import { DataContractDefinitionWidget } from './components/DataContractDefinitionWidget';

/**
 * Replaces the core API docs config (`api:api-docs/config`): API entities of
 * type `datacontract` render with the data contract widget while
 * `features.enable-data-contract` is on. Every other type keeps its default
 * definition widget.
 */
export const apiDocsConfigWithDataContract = apiDocsPlugin
  .getExtension('api:api-docs/config')
  .override({
    params: defineParams =>
      defineParams({
        api: apiDocsConfigRef,
        deps: { configApi: configApiRef },
        factory: ({ configApi }) => {
          const definitionWidgets = defaultDefinitionWidgets();
          const isDataContractEnabled =
            configApi.getOptionalBoolean('features.enable-data-contract') ??
            false;

          return {
            getApiDefinitionWidget: (apiEntity: ApiEntity) => {
              if (
                isDataContractEnabled &&
                apiEntity.spec.type === 'datacontract'
              ) {
                return {
                  type: 'datacontract',
                  title: 'DataContract',
                  rawLanguage: 'yaml',
                  component: (definition: string) => (
                    <DataContractDefinitionWidget definition={definition} />
                  ),
                };
              }

              return definitionWidgets.find(
                d => d.type === apiEntity.spec.type,
              );
            },
          };
        },
      }),
  });

/**
 * Module for the core `api-docs` plugin: install it next to
 * `@backstage/plugin-api-docs/alpha` (installed by package discovery).
 */
export const dataContractApiDocsModule = createFrontendModule({
  pluginId: 'api-docs',
  extensions: [apiDocsConfigWithDataContract],
});
